import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const initialState = {
  channelId: null,
  premiumId: null,
  videoId: null,
  redirectUrl: '',
  promoCode: '',
}

export const usePurchaseStore = create(
  persist(
    set => ({
      ...initialState,
      reset: () => set(initialState),
      setRedirectUrl: redirectUrl => set({ redirectUrl }),
      setChannelId: channelId => set({ channelId }),
      setPremiumId: premiumId => set({ premiumId }),
      setVideoId: videoId => set({ videoId }),
      setPromoCode: promoCode => set({ promoCode }),
    }),
    {
      name: 'purchase',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
